export default {
  header: {
    id: 'dashboard_order_document_actions_header',
    defaultMessage: 'Documents',
  },
}
